import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Find.css";
import axios from "axios";
import Footer from "./Footer";
import Header from "./Header";
import AdLeft from "./AdLeft";
import AdRight from "./AdRight";
const API_BASE = process.env.REACT_APP_API_BASE;

function PwFind() {
    const [birthDate, setBirthDate] = useState("");
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [id, setId] = useState("");
    const [email, setEmail] = useState("");
    const [elementBox, setElementBox] = useState(false);
    const [authNum, setAuthNum] = useState("");
    const [authCheck, setAuthCheck] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0); // 초 단위
    const [isExpired, setIsExpired] = useState(null);
    const [sending, setSending] = useState(false);
    const [isRequested, setIsRequested] = useState(false);


    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleDateChange = (e) => {
        setBirthDate(e.target.value); // 선택된 날짜를 상태로 저장
    };

    const elementToggleBox = () => {
        setElementBox(!elementBox);
    };

    const handlePw = () => {
        console.log("Name:", name);
        console.log("BirthDate:", birthDate);
        console.log("Id:", id);
        console.log("==========================");
        if (name === "") {
            alert("이름을 입력하세요.");
        } else if (birthDate === "") {
            alert("생년월일을 입력하세요.");
        } else if (id === "") {
            alert("아이디를 입력하세요.");
        } else if (email === "") {
            alert("이메일을 입력하세요.");
        } else if (!authCheck) {
            alert("이메일 인증을 확인해주세요");
        } else {
            alert(
                "회원의 정보가 확인되면 임시비밀번호가 생성됩니다\n" +
                "비밀번호를 복사해주세요"
            );

            const userData = {
                name: name,
                birthDate: birthDate,
                username: id,
                email: email,
            };

            const url = `${process.env.REACT_APP_SPRING_API_URL}/api/pwFind`;

            axios
                .post(url, userData)
                .then((response) => {
                    if (
                        window.confirm(
                            `${name}님의 임시 비밀번호는 "${response?.data}"입니다.\n복사하시겠습니까?`
                        )
                    ) {
                        navigator.clipboard
                            .writeText(response?.data)
                            .then(() => {
                                alert(
                                    "복사되었습니다!\n" + "내 정보에서 비밀번호를 변경해주세요!"
                                );
                            })
                            .catch((err) => {
                                alert("복사 실패: " + err);
                            });
                    }
                    navigate("/Login");
                })
                .catch((error) => {
                    const msg = error.response?.data || "입니다";
                    alert(msg);
                });
        }
    };

    const handleSend = (e) => {
        e.preventDefault();
        if (!isValidEmail(email)) {
            alert("적절한 이메일 형식이 아닙니다");
            return;
        }
        if (timeLeft > 0) {
            alert("인증번호 유효시간이 남아있습니다. 잠시 후 다시 시도해주세요.");
            return;
        }

        setSending(true);
        const userData = {
            mail: email,
        };
        const url = `${process.env.REACT_APP_SPRING_API_URL}/api/passwordMailSend`;

        axios
            .post(url, userData)
            .then((response) => {
                alert(`인증번호 발송되었습니다`);

                setTimeLeft(300);
                setIsExpired(false);
                setIsRequested(true);
            })
            .catch((err) => {
                const msg = err.response?.data;
                alert(msg);
                alert("작성하신 이메일을 다시 확인해주세요.");
            })
            .finally(() => {
                setSending(false);
            });
    };

    const handleCheck = (e) => {
        e.preventDefault();

        if (isExpired) {
            alert("인증 시간이 만료되었습니다. 다시 요청해주세요.");
            return;
        }

        if (!email) {
            alert("이메일을 입력해주세요.");
            return;
        }

        axios
            .get(`${process.env.REACT_APP_SPRING_API_URL}/api/mailCheck`, {
                params: {
                    email: email, // ✅ 추가
                    authNum: authNum,
                },
                withCredentials: true, //
            })
            .then((response) => {
                alert(response.data); // "인증이 완료되었습니다."
                setAuthCheck(true);
                setTimeLeft(0);
                setIsExpired(false);
            })
            .catch((err) => {
                alert(err.response?.data || "인증에 실패했습니다.");
                setAuthCheck(false);
            });
    };

    useEffect(() => {
        if (timeLeft <= 0) {
            setIsExpired(true);
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    // 타이머 UI 변환
    const formatTime = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };

    return (
        <div className="Find">
            <Header />
            {/* 좌측 광고 */}
            <div className="AdLeft-container">
                <AdLeft />
            </div>
            {/* 우측 광고 */}
            <div className="AdRight-container">
                <AdRight />
            </div>
            <header className="Find-header">
                <div className="Find-location-container">
                    <div className="Login-location-element">
                        <div className="Login-location">
                            <button
                                className="Login-location-button"
                                type="button"
                                onClick={() => navigate("/")}
                            >
                                홈
                            </button>
                        </div>
                        <div className="Login-location-down"></div>
                        <div className="Login-location">
                            <button
                                className="Login-location-button"
                                type="button"
                                onClick={() => navigate("/login")}
                            >
                                로그인
                            </button>
                        </div>
                        <div className="Login-location-down"></div>
                        <div className="Login-location">
                            <button className="Find-Box-element" onClick={elementToggleBox}>
                                비밀번호 찾기
                            </button>
                        </div>

                        {elementBox && (
                            <div className="Find-Box" id="myBox">
                                <button
                                    className="Find-Box-element"
                                    onClick={() => {
                                        setElementBox(false);
                                        navigate("/idfind");
                                    }}
                                >
                                    아이디 찾기
                                </button>
                                <button
                                    className="Find-Box-element"
                                    onClick={() => {
                                        setElementBox(false);
                                        navigate("/pwfind");
                                    }}
                                >
                                    비밀번호 찾기
                                </button>
                                <button
                                    className="Find-Box-element"
                                    onClick={() => {
                                        setElementBox(false);
                                        navigate("/signup");
                                    }}
                                >
                                    회원가입
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="PwFind-container">
                    <div className="Find-container-element">
                        <div className="Find-element-container">
                            <p className="Find-element-box">이름</p>
                            <input
                                className="Find-element-textbox"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="이름 입력"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handlePw(); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />
                        </div>

                        <div className="Find-element-container">
                            <p className="Find-element-box">생년월일</p>
                            <input
                                className="Find-element-textbox"
                                type="date"
                                id="startDate"
                                value={birthDate}
                                onChange={handleDateChange}
                                max="9999-12-31"
                            />
                        </div>

                        <div className="Find-element-container">
                            <p className="Find-element-box">아이디</p>
                            <input
                                className="Find-element-textbox"
                                type="text"
                                value={id}
                                onChange={(e) => setId(e.target.value)}
                                placeholder="아이디 입력"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handlePw(); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />
                        </div>

                        <div className="Find-element-container">
                            <p className="Find-element-box">이메일</p>
                            <input
                                className="Find-element-textbox"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="example@example.com"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handlePw(); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />
                            <div className="SignUp-same-box">
                                <button
                                    className="SignUp-auth-button"
                                    onClick={handleSend}
                                    disabled={sending}
                                >
                                    {sending ? "전송 중..." : "전송"}
                                </button>
                            </div>
                            {timeLeft > 0 && !authCheck && (
                                <p className="SignUp-timer">
                                    남은 시간: {formatTime(timeLeft)}
                                </p>
                            )}
                        </div>

                        <div className="Find-element-container">
                            <p className="SignUp-element-box">인증번호</p>
                            <input
                                className="SignUp-textbox"
                                type="text"
                                value={authNum}
                                onChange={(e) => setAuthNum(e.target.value)}
                                placeholder="인증번호 입력"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handlePw(); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />
                            <div className="SignUp-same-box">
                                <button
                                    className="SignUp-same-button"
                                    onClick={handleCheck}
                                    disabled={authCheck}
                                >
                                    {authCheck ? "확인 완료" : "확인"}
                                </button>
                                {!authCheck && isExpired && isRequested && (
                                    <p style={{ color: "red" }}>
                                        인증 시간이 만료되었습니다. 다시 요청해주세요.
                                    </p>
                                )}
                            </div>
                        </div>

                        {name === "" ||
                        birthDate === "" ||
                        email === "" ||
                        id === "" ||
                        authNum === "" ? (
                            <div className="Find-find-container">
                                <button
                                    className="Find-find-button"
                                    onClick={handlePw}
                                    style={{ background: "gray" }}
                                >
                                    PW 찾기
                                </button>
                            </div>
                        ) : (
                            <div className="Find-find-container">
                                <button
                                    className="Find-find-button"
                                    onClick={handlePw}
                                    style={{ background: "darkblue" }}
                                >
                                    PW 찾기
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>
            <Footer />
        </div>
    );
}

export default PwFind;